idm = app = (function () {
  var chatWindow,
    currentBreakpoint,
    submitHandlers = [],
    pageInitFunctions = [],
    focusableElementsSelector =
      "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]",
    hasTouch,
    waitForKeyboardToDismiss,
    emailRegexPattern = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    checkFormTimer;

  var KEYS = {
    ESCAPE: 27,
    UP_ARROW: 38,
    DOWN_ARROW: 40,
    LEFT_ARROW: 37,
    RIGHT_ARROW: 39,
    ENTER: 13,
    SPACE: 32,
  };

  function init(config) {
    checkFormTimer = null;

    if (config) {
      idm.appURL = config.appURL;
      idm.flowStage = config.flowStage;
    }

    $("select")
      .dropkick({
        mobile: true,
      })
      .on("change", function () {
        $(this).valid();
      });

    //iPhone 6 chrome refresh workaround
    $("input[type=radio]").change(function () {
      $(".radio").css("webkitTransform", "scale(1)").css("webkitTransform", "");
    });
    $("input[type=checkbox]").change(function () {
      $(".checkbox")
        .css("webkitTransform", "scale(1)")
        .css("webkitTransform", "");
    });

    initExpandableRadioGroups();

    initCustomValidators();

    $(document).on(
      "click",
      "button[type=button][name=_eventId]:not([data-dialog-id-ref])",
      secondaryButtonHandler
    );

    initDialogs();
    initPasswordMaskToggles();
    initTextfieldEvents();

    onResize();
    $(window).on("orientationchange", updateBackground);
    $(window).on("resize", onResize);
    $(window).one("touchstart", function () {
      hasTouch = true;
    });

    $("input").blur(function () {
      if (hasTouch) waitForKeyboardToDismiss = true;
      setTimeout(function () {
        waitForKeyboardToDismiss = false;
      }, 0);
    });

    $('button[type="submit"]').click(function () {
      app.firstSubmit = true;
      app.submitInProgress = true;
    });

    $(document).on(app.getInputEvents(), "input[name]", function () {
      app.submitInProgress = false;
      updateRemoteValidationError($(this));
    });

    normalizeEmailFieldBehavior();

    initPage();

    addStatusIconMarkup();

    initWindowCloseEventHandler();
    if (config?.enableVisibilityChangeEvents) {
      initVisibilityChangeEventHandler();
    }
  }

  function initCustomValidators() {
    //Added email custom Validation. Need to be updated new jquery validate version for new email RFC-5322 Standard.
    addCustomEmailValidation();
    initRequiredFromGroupValidations();
    initRemoteValidationErrors();
  }

  function addCustomEmailValidation() {
    $.validator.methods.email = function (value, element) {
      return this.optional(element) || emailRegexPattern.test(value);
    };
    $.validator.messages.email = function () {
      return "<i18n:message code='createUid.email.error.contactEmailBad'/>";
    };
  }

  function getRequiredFromGroupSelectorForNumRequired(numRequired) {
    var numberNames = ["zero", "one", "two"],
      numRequiredClass = numberNames[numRequired] + "-required";
    return (
      "." +
      numRequiredClass +
      ":not(.dk-select):not(:hidden),." +
      numRequiredClass +
      ".dk-select:visible+select." +
      numRequiredClass
    );
  }

  function initRequiredFromGroupValidations() {
    $.validator.addClassRules({
      "one-required": {
        require_from_group: {
          param: [1, getRequiredFromGroupSelectorForNumRequired(1)],
        },
      },
      "two-required": {
        require_from_group: {
          param: [2, getRequiredFromGroupSelectorForNumRequired(2)],
        },
      },
    });
    $.validator.methods.require_from_group =
      require_from_group_with_checkFrom_fix;
  }

  /*
		This function is a patched version of:
		https://github.com/jquery-validation/jquery-validation/blob/master/src/additional/require_from_group.js
	 */
  function require_from_group_with_checkFrom_fix(value, element, options) {
    var $fields = $(options[1], element.form),
      $fieldsFirst = $fields.eq(0),
      validator = $fieldsFirst.data("valid_req_grp")
        ? $fieldsFirst.data("valid_req_grp")
        : $.extend({}, this),
      isValid =
        $fields.filter(function () {
          return validator.elementValue(this);
        }).length >= options[0];

    // Store the cloned validator for future validation
    $fieldsFirst.data("valid_req_grp", validator);

    // If element isn't being validated, run each require_from_group field's validation rules
    if (
      !$(element).data("being_validated") &&
      !$(element.form).data("_checkingForm")
    ) {
      $fields.data("being_validated", true);
      $fields.each(function () {
        validator.element(this);
      });
      $fields.data("being_validated", false);
    }
    return isValid;
  }

  function checkBackendValidationError(value, element) {
    var name = $(element).attr("name");
    return !window.validationErrors || !validationErrors[name];
  }

  function getBackendValidationErrorMessage(params, element) {
    var name = $(element).attr("name");
    return validationErrors[name];
  }

  function applyValidationErrorsNameMap() {
    var name;
    if (window.validationErrorsNameMap) {
      for (name in validationErrorsNameMap) {
        if (name in validationErrors) {
          var error = validationErrors[name];
          delete validationErrors[name];
          validationErrors[validationErrorsNameMap[name]] = error;
        }
      }
    }
  }

  function applyValidationErrorsToFields() {
    var name;
    for (name in validationErrors) {
      var elem = document.querySelector(
        `[name="${name}"]:not(prism-input-otp)`
      );
      if (!elem) {
        delete validationErrors[name];
      } else {
        $(elem).attr("data-rule-backendvalidation", "true");
        $(elem).valid();
      }
    }
  }

  function focusFirstValidationError() {
    $("main form input[name]")
      .filter(function () {
        return $(this).attr("name") in validationErrors;
      })
      .first()
      .focus();
  }

  function initRemoteValidationErrors() {
    $.validator.addMethod(
      "backendValidation",
      checkBackendValidationError,
      getBackendValidationErrorMessage
    );

    if (window.validationErrors) {
      applyValidationErrorsNameMap();
      applyValidationErrorsToFields();
      focusFirstValidationError();
    }
  }

  function addStatusIconMarkup() {
    var spanElem = $('<span class="icon unverified"></span>'),
      wrapperElem = $('<div class="textfield-wrapper"></div>');
    $("input[data-status]").each(function () {
      $(this)
        .wrap(wrapperElem)
        .after(spanElem)
        .css("padding-right", spanElem.outerWidth(true));
    });
  }

  function escapeSelector(selector) {
    if (selector) return selector.replace(/([:.\[\],=@])/g, "\\$1");
  }

  function escapeIdSelector(selector) {
    return "#" + escapeSelector(selector);
  }

  function initExpandableRadioGroups() {
    var expandableRadioGroupItems = $("input[type=radio][aria-controls]");
    if (expandableRadioGroupItems.length) {
      $("input[name=" + expandableRadioGroupItems.attr("name") + "]").change(
        function () {
          var triggerElem = $(this),
            expandedTriggerElem = $(
              "input[type=radio][aria-controls][aria-expanded=true]"
            ),
            elemToBeShown = $(
              escapeIdSelector(triggerElem.attr("aria-controls"))
            ),
            elemToBeHidden = $(
              escapeIdSelector(expandedTriggerElem.attr("aria-controls"))
            );
          if (!elemToBeShown.is(elemToBeHidden)) {
            elemToBeHidden.slideUp(function () {
              $(this)
                .attr("hidden", true)
                .find(".invalid")
                .removeClass("invalid");
              expandedTriggerElem.attr("aria-expanded", "false");
            });
            elemToBeShown
              .prop("hidden", false)
              .hide()
              .slideDown(function () {
                triggerElem.attr("aria-expanded", "true");
              });
          }
        }
      );
    }
  }

  function updateRemoteValidationError(field) {
    field.removeAttr("data-rule-backendvalidation");
    if (window.validationErrors) {
      var name = field.attr("name");
      if (validationErrors[name]) {
        delete validationErrors[name];
        field.valid();
      }
    }
  }

  function normalizeEmailFieldBehavior() {
    $.valHooks["email"] = {
      get: function (el) {
        return $.trim(el.value);
      },
    };
    $("input[type=email]").on("blur", function () {
      $(this).val($(this).val());
    });
  }

  function updateBackground() {
    $("#background").css("height", window.innerHeight);
  }

  function updateBackgroundWhenAllowed() {
    var heightIncreasing = window.innerHeight > $("#background").height();
    if (!hasTouch || heightIncreasing) updateBackground();
  }

  function onResize() {
    var bp = getBreakpoint();
    if (bp !== currentBreakpoint) {
      currentBreakpoint = bp;
      onBreakpointChange();
    }
    var dialog = $(".tooltip:visible, .overlay:visible");
    if (dialog.length) updateDialog(dialog);
    updateTextfields();
    updateBackgroundWhenAllowed();
  }

  function sendEventByBeacon(data) {
    app.getNavigator().sendBeacon(
      app.appURL,
      new Blob([new URLSearchParams(data)], {
        type: "application/x-www-form-urlencoded",
      })
    );
  }

  function sendEventByAjax(data) {
    $.ajax({
      url: app.appURL,
      type: "post",
      async: false,
      dataType: "json",
      data: data,
    });
  }

  function sendEvent(data) {
    if (app.getNavigator().sendBeacon) {
      sendEventByBeacon(data);
    } else {
      sendEventByAjax(data);
    }
  }

  function initWindowCloseEventHandler() {
    $(window).on("beforeunload", function () {
      if (app.flowStage !== "complete" && !app.submitInProgress) {
        const eventData = {
          _eventId: "closeEvent",
          ajaxSource: "true",
        };
        sendEvent(eventData);
      }
    });
  }

  function initVisibilityChangeEventHandler() {
    document.addEventListener("visibilitychange", function () {
      if (app.flowStage !== "complete" && !app.submitInProgress) {
        const eventData = {
          _eventId:
            app.getDocument().visibilityState === "hidden"
              ? "visibilityChangeHidden"
              : "visibilityChangeVisible",
          ajaxSource: "true",
        };
        sendEvent(eventData);
      }
    });
  }

  function datalayerEventCallback() {
    var extraLogData = {},
      lastEvent =
        (window.digitalData &&
          window.digitalData.event[window.digitalData.event.length - 1]) ||
        null,
      lastEventIsUnload =
        lastEvent &&
        lastEvent.eventInfo.eventMethod === "c-tracking-log-page-unload";
    if (
      app.flowStage !== "complete" &&
      !app.submitInProgress &&
      lastEventIsUnload
    ) {
      extraLogData.temp = {
        lastEventAction: "window closed",
      };
    }
    return extraLogData;
  }

  function onBreakpointChange() {
    var dialogElem = $(".tooltip:visible, .overlay:visible");
    if (dialogElem.length) updateDialogType(dialogElem);
  }

  function openChatWindow(href) {
    if (chatWindow && !chatWindow.closed) {
      chatWindow.focus();
    } else {
      chatWindow = window.open(
        href,
        "ChatWindow",
        "alwaysRaised=1,location=1,status=1,scrollbars=1,resizable=1,menubar=1"
      );
    }
  }

  function initDialogs() {
    $("[data-dialog-id-ref]").click(function () {
      var dialogElem = $("#" + $(this).data("dialogIdRef"));
      showOverlay(dialogElem, $(this));
    });
    $("[role=dialog] .close, [role=dialog] .cancel").click(function () {
      hideDialog($(this).closest("[role=dialog]"));
    });
    var lastActiveElement = null;
    var isMouseDown = false;
    $(document).on({
      keydown: function (event) {
        if (event.keyCode === KEYS.ESCAPE) {
          hideDialog($(".tooltip:visible, .overlay:visible"));
        }
      },
      mousedown: function () {
        isMouseDown = true;
      },
      mouseup: function () {
        isMouseDown = false;
      },
      click: function (event) {
        var elem = $(event.target);
        if (elem.closest(".info, .overlay, .tooltip").length) return;
        var tooltipElem = $(".tooltip:visible"),
          triggerElem = tooltipElem.data("triggerElem");
        if (triggerElem && triggerElem.is(elem)) return;
        hideDialog(tooltipElem);
      },
      focusout: function (event) {
        lastActiveElement = event.target;
      },
      focusin: function (event) {
        var currentdialogElem = $(".tooltip:visible, .overlay:visible");
        if (
          !isMouseDown &&
          currentdialogElem.length &&
          $(event.target).closest(".overlay, .tooltip").length === 0
        ) {
          var firstFocusableElement = currentdialogElem
            .find(focusableElementsSelector)
            .first();
          if (firstFocusableElement.is(lastActiveElement))
            focusLastElement(currentdialogElem);
          else focusFirstElement(currentdialogElem);
        }
      },
    });
  }

  function initPasswordMaskToggles() {
    $("[data-password-mask-toggle-ref]").on("click", function () {
      var toggleButton = $(this);
      var targetElem = $(
        "#" + toggleButton.attr("data-password-mask-toggle-ref")
      );
      if (targetElem.length) {
        if (targetElem.attr("type") === "text") {
          targetElem.attr("type", "password");
          toggleButton.text(toggleButton.attr("data-label-show"));
          toggleButton.attr(
            "aria-label",
            toggleButton.attr("data-aria-label-show")
          );
        } else {
          targetElem.attr("type", "text");
          toggleButton.text(toggleButton.attr("data-label-hide"));
          toggleButton.attr(
            "aria-label",
            toggleButton.attr("data-aria-label-hide")
          );
        }
      }
    });
  }

  function focusContainer(container) {
    container.attr("tab-index", 0);
    container.focus();
  }

  function focusFirstElement(container) {
    var focusableElements = container.find(focusableElementsSelector);
    focusableElements.first().focus();
  }

  function focusLastElement(container) {
    var focusableElements = container.find(focusableElementsSelector);
    focusableElements.last().focus();
  }

  function updateDialogType(dialogElem) {
    var type = dialogElem.data("dialogType");
    if (type === "auto") {
      type = getBreakpoint() === "small" ? "overlay" : "tooltip";
      dialogElem.removeClass("tooltip overlay");
    }
    dialogElem.addClass(type);
    updateDialog(dialogElem);
    $("html").css("overflow", type === "overlay" ? "hidden" : "");
  }

  function showDialog(dialogElem, anchorElem) {
    if (!dialogElem.is(":visible")) {
      hideDialog($(".tooltip:visible, .overlay:visible"));
      dialogElem.data("dialogType", "auto");
      updateDialogType(dialogElem);
      if (dialogElem.hasClass("overlay")) showOverlay(dialogElem, anchorElem);
      else showTooltip(dialogElem, anchorElem);
    }
  }

  function hideDialog(dialogElem) {
    if (dialogElem.is(":visible")) {
      if (dialogElem.is(".tooltip")) hideTooltip(dialogElem);
      else hideOverlay(dialogElem);
      if (idm.onDialogClose) {
        idm.onDialogClose(dialogElem);
      }
    }
  }

  function showOverlay(overlayElem, triggerElem) {
    if (triggerElem) triggerElem.addClass("active");
    if (!overlayElem.data("dialogType"))
      overlayElem.data("dialogType", "overlay");
    overlayElem.data("triggerElem", triggerElem);
    setTimeout(
      function () {
        updateDialogType(overlayElem);
        overlayElem.prop("hidden", false);
        overlayElem.css("display", "");
        overlayElem.find("> .content").css("max-height", "100%");
        focusContainer(overlayElem);
      },
      waitForKeyboardToDismiss ? 500 : 0
    );
  }

  function hideOverlay(overlayElem) {
    overlayElem.attr("hidden", true).css("display", "");
    overlayElem.find("> .content").css("max-height", "");
    $("html").css("overflow", "");
    focusTriggerElem(overlayElem);
  }

  function showTooltip(tipElem, triggerElem) {
    triggerElem.addClass("active");
    if (!tipElem.data("dialogType")) tipElem.data("dialogType", "tooltip");
    tipElem.data("triggerElem", triggerElem);
    updateDialogType(tipElem);
    positionTooltip(tipElem);
    tipElem.removeAttr("hidden");
    focusContainer(tipElem);
  }

  function hideTooltip(tipElem) {
    tipElem.attr("hidden");
    focusTriggerElem(tipElem);
  }

  function focusTriggerElem(dialogElem) {
    var triggerElem = dialogElem.data("triggerElem");
    if (triggerElem) {
      triggerElem.removeClass("active");
      if ($(":focus").closest(".tooltip, .overlay").is(dialogElem))
        triggerElem.focus();
    }
  }

  function updateDialog(dialogElem) {
    if (dialogElem.is(".tooltip")) positionTooltip(dialogElem);
    else {
      var winHeight = window.innerHeight || $(window).height();
      dialogElem.css({ height: winHeight, left: "", top: "" });
      var wasHidden = !dialogElem.is(":visible");
      dialogElem.prop("hidden", false);
      var contentElem = dialogElem.find("> .content");
      contentElem.css({
        top: Math.max(0, (winHeight - contentElem.outerHeight()) / 2),
        left: (dialogElem.outerWidth() - contentElem.outerWidth()) / 2,
      });
      if (wasHidden) dialogElem.attr("hidden", true);
    }
  }

  function positionTooltip(tipElem) {
    var anchorElem,
      left,
      top,
      anchorPos,
      topOffset = 20;

    anchorElem = tipElem.data("triggerElem");
    if (!anchorElem) return;

    anchorPos = anchorElem.offset();
    anchorPos.left -= $(window).scrollLeft();
    anchorPos.top -= $(window).scrollTop();

    left =
      anchorPos.left + anchorElem.outerWidth() / 2 - tipElem.outerWidth() / 2;

    if (
      anchorPos.top +
        anchorElem.outerHeight() +
        topOffset +
        tipElem.outerHeight() >
      $(window).height()
    )
      top = anchorPos.top - topOffset - tipElem.outerHeight();
    else top = anchorPos.top + anchorElem.outerHeight() + topOffset;

    left = Math.max(
      0,
      Math.min(left, $(window).width() - tipElem.outerWidth())
    );
    top = Math.max(
      0,
      Math.min(top, $(window).height() - tipElem.outerHeight())
    );

    left += $(window).scrollLeft();
    top += $(window).scrollTop();

    tipElem.css({ height: "auto", left: left, top: top });
  }

  function getBreakpoint() {
    return $("#breakpoints").css("font-family");
  }

  function registerPageInitFunction(func) {
    pageInitFunctions.push(func);
  }

  function initPage() {
    for (var funcName in pageInitFunctions) pageInitFunctions[funcName]();
  }

  function getDropkickElem(elem) {
    var dkElemIndex = $(elem).attr("data-dkcacheid");
    if (dkElemIndex) return $("#dk" + dkElemIndex + "-combobox");
    return null;
  }

  function errorElemInUse(validator, errorElem) {
    return !!validator.invalidElements().filter(function () {
      return !!validator.errorsFor(this).is(errorElem);
    }).length;
  }

  function getDisableableSubmitButton(formElem) {
    return $(formElem).find(
      'button[aria-disabled][name="_eventId"]:not([type=button])'
    );
  }

  function checkFormWithoutTriggeringErrors(formElem) {
    var validator = formElem.validate(),
      originalSubmittedValues = validator.submitted,
      isValid;
    validator.submitted = {};
    formElem.data("_checkingForm", true);
    isValid = validator.checkForm() && !validator.pendingRequest;
    formElem.removeData("_checkingForm");
    validator.submitted = originalSubmittedValues;
    return isValid;
  }

  function updateSubmitButtonDisabledState(formElem) {
    var disableableSubmitButton = getDisableableSubmitButton(formElem);
    if (disableableSubmitButton.length) {
      disableableSubmitButton.attr(
        "aria-disabled",
        !checkFormWithoutTriggeringErrors(formElem)
      );
    }
    updateFormErrorsElem(formElem);
  }

  function getFormErrorsId(formElem) {
    return formElem.attr("id") + "-errors";
  }

  function updateFormErrorsElem(formElem) {
    try {
      var validator = formElem.validate(),
        formErrorsElem = $(`#${getFormErrorsId(formElem)}`),
        formErrorsMarkup = "";
      if (validator.errorList.length) {
        $.each(validator.errorList, function () {
          formErrorsMarkup += this.message + " ";
        });
      }
      formErrorsElem.html(formErrorsMarkup);
    } catch (e) {
      console.error(e);
    }
  }

  function startDelayedSubmitButtonUpdate(formElem) {
    if (checkFormTimer) clearTimeout(checkFormTimer);
    checkFormTimer = setTimeout(function () {
      updateSubmitButtonDisabledState(formElem);
      checkFormTimer = null;
    }, 300);
  }

  function formInputHasRemoteRule(formInput) {
    return formInput.rules() && "remote" in formInput.rules();
  }

  function initFormDisabledSubmitButton(formElem) {
    var disabledSubmitButton = getDisableableSubmitButton(formElem);
    if (disabledSubmitButton.length) {
      disabledSubmitButton.click(function (e) {
        if ($(this).attr("aria-disabled") === "true") {
          e.preventDefault();
        }
      });
      $(document).on(app.getInputEvents(), "input[name]", function () {
        if (!formInputHasRemoteRule($(this))) {
          updateSubmitButtonDisabledState(formElem);
        }
      });
      $(document).ajaxComplete(function () {
        updateSubmitButtonDisabledState(formElem);
      });
      const formErrorsId = getFormErrorsId(formElem);
      formElem.append(`<p id="${formErrorsId}" hidden></p>`);
      disabledSubmitButton.attr("aria-describedby", formErrorsId);
      updateSubmitButtonDisabledState(formElem);
    }
  }

  function createNewValidator(options) {
    options = options || {};
    var validator,
      validationGroups = {},
      formElem = $(options.formId || "main form:eq(0)");

    $("[data-validation-group]").each(function () {
      var inputs = $(this).find("input[name]");
      validationGroups[$(this).data("validationGroup")] = inputs
        .map(function () {
          return $(this).attr("name");
        })
        .get()
        .join(" ");
    });
    if (!$.isEmptyObject(validationGroups)) {
      $.extend(options, {
        groups: validationGroups,
      });
    }

    validator = formElem.validate(
      $.extend(
        {},
        {
          ignore:
            ":hidden:not(select[data-dkcacheid]),prism-input-otp,prism-input-otp *",
          errorElement: "div",
          errorClass: "invalid",
          errorPlacement: function (error, element) {
            var anchorElement;
            if (element.is("input[type=radio]")) {
              anchorElement = element.closest("fieldset");
            } else if (element.is("input[type=checkbox]")) {
              anchorElement = element.closest(".checkbox-container");
            } else if (element.is("input[role=combobox]")) {
              anchorElement = element.closest(".combobox-wrapper");
            } else {
              anchorElement = element.closest("[data-validation-group]");
              if (!anchorElement.length) {
                anchorElement = element.closest(".textfield-wrapper");
              }
              if (!anchorElement.length) {
                anchorElement = element;
              }
            }
            error.addClass("screen-reader-text");
            error.insertAfter(anchorElement);
            setTimeout(function () {
              error.removeClass("screen-reader-text");
            }, 250);
          },
          submitHandler: function (form) {
            var submitCheck = true,
              formnovalidate =
                $("main button[type='submit']").eq(0).attr("formnovalidate") !==
                undefined;
            for (var i = 0; i < submitHandlers.length; i++) {
              if (submitHandlers[i](form, formnovalidate) === false) {
                submitCheck = false;
              }
            }
            if (submitCheck) {
              if (
                $(this.submitButton).hasClass("cancel") ||
                $(this.submitButton).attr("formnovalidate") !== undefined ||
                $(form).valid()
              ) {
                form.submit();
                return;
              }
            }
            app.submitInProgress = false;
          },
          invalidHandler: function () {
            app.submitInProgress = false;
          },
          showErrors: function (errorMap, errorList) {
            var validator = this;
            if (window.validationErrors) {
              for (var name in validationErrors) {
                var elem = $('[name="' + escapeSelector(name) + '"]');
                var ignore = elem.not(validator.settings.ignore).length === 0;
                if (!ignore && !elem.is("[formnovalidate]")) {
                  errorMap[name] = validationErrors[name];
                  errorList.push({
                    message: errorMap[name],
                    element: this.findByName(name)[0],
                  });
                }
              }
            }
            this.defaultShowErrors();
            errorList.forEach(function (error) {
              $.each(error.element.attributes, function () {
                if (this.name.indexOf("data-validate-") === 0) {
                  validator
                    .errorsFor(error.element)
                    .attr(this.name, this.value);
                }
              });
            });
            if (!formElem.data("_checkingForm")) {
              startDelayedSubmitButtonUpdate(formElem);
            }
          },
          highlight: function (element, errorClass, validClass) {
            $.validator.defaults.highlight.apply(this, arguments);
            $(element).attr("aria-invalid", true);
            var dkElem = getDropkickElem(element);
            if (dkElem) dkElem.attr("aria-invalid", true);
          },
          unhighlight: function (element, errorClass, validClass) {
            if (!this.invalid[element.name]) {
              var dkElem = getDropkickElem(element);
              $.validator.defaults.unhighlight.apply(this, arguments);
              $(element).removeAttr("aria-invalid");
              if (dkElem) dkElem.removeAttr("aria-invalid");
              if (!errorElemInUse(this, this.errorsFor(element))) {
                this.errorsFor(element).remove();
              }
            }
          },
          onkeyup: handleKeyUp,
        },
        options
      )
    );

    validator.resetElement = resetElement;

    initFormDisabledSubmitButton(formElem);

    return validator;
  }

  function resetElement(elem) {
    delete this.invalid[elem.name];
    delete this.submitted[elem.name];
    this.resetElements([elem]);
  }

  //code derived from $.validator.defaults.onkeyup
  function handleKeyUp(element, event) {
    var excludedKeys = [16, 17, 18, 20, 35, 36, 37, 38, 39, 40, 45, 144, 225],
      keyShouldBeIgnored =
        (event.which === 9 && this.elementValue(element) === "") ||
        $.inArray(event.keyCode, excludedKeys) !== -1,
      validationIsActive =
        element.name in this.submitted || element.name in this.invalid;

    if (validationIsActive && !keyShouldBeIgnored) {
      var rules = $(element).rules();
      if (rules.remote) {
        validateElementOnDelay(this, element);
        return false;
      }
      this.element(element);
    }
  }

  function validateElementOnDelay(validator, element) {
    var $element = $(element),
      timer = $element.data("validationTimer");
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      validator.element(element);
      $element.removeData("validationTimer");
    }, 300);
    $element.data("validationTimer", timer);
  }

  function getInputEvents() {
    var inputEvents = "input",
      isIE11 =
        !!app.getWindow().MSInputMethodContext &&
        !!app.getDocument().documentMode;
    if (isIE11) {
      inputEvents += " change";
    }
    return inputEvents;
  }

  function initTextfieldEvents() {
    var withBadge = $(
      ".textfield-wrapper--with-badge input, .textfield-wrapper--with-badge .textfield"
    );
    withBadge.on("focus", updateThisTextfieldWithBadge);
    withBadge.on("blur", updateThisTextfieldWithBadge);
    withBadge.each(observeBadgeOnThisTextfield);
  }

  function updateTextfields() {
    $(
      ".textfield-wrapper--with-badge input, .textfield-wrapper--with-badge .textfield"
    ).each(updateThisTextfieldWithBadge);
  }

  function updateThisTextfieldWithBadge() {
    updateTextfieldWithBadge($(this));
  }

  function observeBadgeOnThisTextfield() {
    var thisField = $(this);
    var observer = new MutationObserver(function () {
      updateTextfieldWithBadge(thisField);
    });
    observer.observe(thisField.siblings(".badge")[0], { attributes: true });
  }

  function updateTextfieldWithBadge(field) {
    var badge = field.siblings(".badge");
    var showNextUI = document.querySelector("html.next") !== null;
    field.css("padding-right", "");
    if (badge && badge.is(":visible")) {
      field.css(
        "padding-right",
        parseFloat(field.css("padding-right")) * (showNextUI ? 1 : 1.5) +
          badge.outerWidth(true)
      );
    }
  }

  function getWindow() {
    return window;
  }

  function getDocument() {
    return document;
  }

  function getNavigator() {
    return navigator;
  }

  return {
    KEYS: KEYS,
    init: init,
    updateRemoteValidationError: updateRemoteValidationError,
    submitHandlers: submitHandlers,
    showOverlay: showOverlay,
    hideOverlay: hideOverlay,
    openChatWindow: openChatWindow,
    getBreakpoint: getBreakpoint,
    registerPageInitFunction: registerPageInitFunction,
    createNewValidator: createNewValidator,
    getInputEvents: getInputEvents,
    getDocument: getDocument,
    getWindow: getWindow,
    getNavigator: getNavigator,
    datalayerEventCallback: datalayerEventCallback,
    pageInfo: {},
    config: {},
  };
})();

appendPhoneNumber = function () {
  var phoneNumber = $("#phoneNumber")
    .val()
    .replace(/[^0-9]+/g, "");
  if (phoneNumber.match(/^\d+$/)) {
    $("#phoneNumber-areaCode").val(phoneNumber.substring(0, 3));
    $("#phoneNumber-prefix").val(phoneNumber.substring(3, 6));
    $("#phoneNumber-subscriberNumber").val(phoneNumber.substring(6, 10));
  } else {
    $("#phoneNumber-areaCode").val("");
    $("#phoneNumber-prefix").val("");
    $("#phoneNumber-subscriberNumber").val("");
  }
};

displayPhoneNumber = function (trigger) {
  var phoneNumber =
      "(" +
      $("#phoneNumber-areaCode").val() +
      ") " +
      $("#phoneNumber-prefix").val() +
      "-" +
      $("#phoneNumber-subscriberNumber").val(),
    phoneNumberElem = $("#phoneNumber");

  if (phoneNumber.length === 14) {
    phoneNumberElem.val(phoneNumber);
    if (trigger || trigger === undefined)
      phoneNumberElem.trigger(app.getInputEvents());
  }
};

appendDateOfBirth = function () {
  var dateOfBirth = $("#dateOfBirth")
    .val()
    .replace(/[^0-9]+/g, "");
  if (dateOfBirth.match(/^\d+$/)) {
    for (var i = 0; i < dateOfBirth.length; i++) {
      $("#dateOfBirth\\.month").val(dateOfBirth.substring(0, 2));
      $("#dateOfBirth\\.date").val(dateOfBirth.substring(2, 4));
      $("#dateOfBirth\\.year").val(dateOfBirth.substring(4, 8));
    }
  }
};

customDateOfBirthValidation = function () {
  var currentDate = new Date();
  var dobMonth = parseInt($("#dateOfBirth\\.month").val(), "10") - 1;
  var dobDate = parseInt($("#dateOfBirth\\.date").val(), "10");
  var dobYear = parseInt($("#dateOfBirth\\.year").val(), "10");
  var dobYearlength = $("#dateOfBirth\\.year").val().length;
  var dob = new Date(dobYear, dobMonth, dobDate);
  return (
    dob.getFullYear() == dobYear &&
    dobYearlength === 4 &&
    dob.getMonth() == dobMonth &&
    dob.getDate() == dobDate &&
    currentDate > dob
  );
};

getInputValue = function (name) {
  return $('input[name="' + name + '"]')[0].value;
};

function preventPopupDefaultClickHandler(event) {
  if (event.target.nodeName.toLowerCase() !== "a" || !event.target.href)
    event.preventDefault();
}

function setupFieldtipPopupActivation() {
  var fieldTip = $(".field-tip");

  fieldTip.click(function (event) {
    preventPopupDefaultClickHandler(event);
    var popup = $(this).children(".tip-popup");
    if (popup.is(":visible")) return;
    popup.css("zIndex", "");
    if (idm.getBreakpoint() === "large") popup.show();
    else idm.showOverlay(popup);
  });

  fieldTip.mouseout(function () {
    if (idm.getBreakpoint() === "large")
      $(this).children(".tip-popup:not(.tip-overlay)").hide();
  });

  $(".tip-popup").click(preventPopupDefaultClickHandler);
}

function setupStatusIconPopupActivation() {
  var statusIcon = $(".status-icon");

  statusIcon.click(function (event) {
    event.preventDefault();
    var popup = $(this).closest(".form-field").find("aside.error");
    idm.showOverlay(popup);
  });

  $(".form-field aside").click(preventPopupDefaultClickHandler);
}

function appendQuery(uri, query) {
  return hasQuery(uri) ? uri + "&" + query : uri + "?" + query;
}

function hasQuery(uri) {
  return uri.indexOf("?") >= 0;
}

$(document).ready(function () {
  setupFieldtipPopupActivation();
  setupStatusIconPopupActivation();
});
